import React, { ReactNode } from 'react';
import { AnimatePresence as FramerAnimatePresence } from 'framer-motion';

interface AnimatePresenceProps {
  children?: ReactNode;
  initial?: boolean;
  mode?: 'sync' | 'wait' | 'popLayout';
  onExitComplete?: () => void;
  presenceAffectsLayout?: boolean;
}

export const AnimatePresence: React.FC<AnimatePresenceProps> = (props) => {
  const Component = FramerAnimatePresence as any;
  return <Component {...props} />;
};

